module.exports = __webpack_public_path__ + "static/img/V-M50@2x.791f6069.png";